import { shallowEqual, useSelector } from "react-redux";

import label from "../labels/common_en.json";
export default function ApplicationFooter() {
  let { apiRepoVersion } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );

  return (
    <div className="footer">
      <div className=" text-start">
        <span>{label.Disclaimer}</span>
      </div>
      <div className="text-center">
        <span>{label.official_website_of_maharashtra_public}</span>
      </div>
      <div className="col-sm-1 text-center">
        {process.env.REACT_APP_VERSION} {apiRepoVersion}
      </div>
    </div>
  );
}
